import { EFormFieldExam } from '../enums/EFormField'
import { IHealthRecord } from '../interfaces'

export const C_HEALTH_RECORD_DEFAULT: IHealthRecord = {
  attachment: null,
  diagnosis: {
    diagnosis: '',
    solution: ''
  },
  examinations: {
    body_part_examination: [],
    subclinical_diagnosis: [
      {
        key: EFormFieldExam.SubclinicalDiagnosis,
        value: '',
        name: EFormFieldExam.SubclinicalDiagnosis,
        note: ''
      }
    ],
    physical_examination: [],
    pathological_process: []
  }
}
